import { jwt } from 'src/utils'
import { APP_SPACE_AUTH, APP_SPACE_MEMBERSHIP } from './useSessionData.constants'

const useSessionData = () => {
  const getUserData = () => {
    try {
      const localStorageItem = localStorage.getItem(APP_SPACE_AUTH)

      if (!localStorageItem) {
        return {}
      }

      const { id_token, profile } = JSON.parse(localStorageItem)
      const { id, name, ucode } = profile

      return {
        id: Number(id),
        token: id_token,
        name,
        ucode,
        marketplaceId: Number(id),
        isLogged: !jwt.isExpired(id_token)
      }
    } catch {
      return {}
    }
  }

  const getMembershipData = () => {
    try {
      const localStorageItem = localStorage.getItem(APP_SPACE_MEMBERSHIP)

      if (!localStorageItem) {
        return {}
      }

      const { state } = JSON.parse(localStorageItem)
      const { membershipSlug, membershipData } = state

      return {
        id: membershipData?.id,
        name: membershipData?.name,
        slug: membershipSlug
      }
    } catch {
      return {}
    }
  }

  const user = getUserData()
  const membership = getMembershipData()

  return { user, membership }
}

export default useSessionData
